import { useState } from 'react';
import { lastEmail, login } from '../../lib/api.ts';
import { BrandMark, Button, Field, Input } from '../../components/ui.tsx';

export function LoginPage() {
  // the email of the last session is kept on the device, so usually only the password is left
  const [email, setEmail] = useState(lastEmail);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  return (
    <div className="login">
      <form className="login-card" method="post" action="/api/v1/auth/login" onSubmit={async (e) => {
        e.preventDefault();
        setBusy(true);
        setError('');
        try { await login(email.trim(), password); } catch (err) { setError((err as Error).message); } finally { setBusy(false); }
      }}>
        <BrandMark />
        <h1>Трекер трат</h1>
        <Field label="Email"><Input type="email" name="email" id="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus={!email} /></Field>
        <Field label="Пароль"><Input type="password" name="password" id="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required autoFocus={!!email} /></Field>
        {error ? <p className="form-error" role="alert">{error}</p> : null}
        <Button type="submit" variant="primary" busy={busy}>Войти</Button>
        <p className="muted small login-note">Вход сохраняется на этом устройстве на 90 дней и продлевается при каждом открытии.</p>
      </form>
    </div>
  );
}
